import { useSyncExternalStore } from 'react'

type UiState = { open: boolean }

let ui: UiState = { open: false }
const listeners = new Set<() => void>()

function set(next: UiState) {
  if (next.open === ui.open) return
  ui = next
  listeners.forEach((l) => l())
}

export function openReportIssue(): void {
  set({ open: true })
}

export function closeReportIssue(): void {
  set({ open: false })
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

const getSnapshot = () => ui

export function useReportIssueUi(): UiState {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
